import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GraficoBarra } from '../models/grafico';
import { GlobalService } from './global.service';
import { UtilitarioService } from './utilitario.service';
import * as Chartist from 'chartist';
import { globals } from '../globals';
import { Irradiacao } from '../models/irradiacao';

@Injectable({
  providedIn: 'root'
})
export class GraficoService {
  constructor(private globalService: GlobalService, private http: HttpClient,
    private utilitarioService: UtilitarioService) { }

  // animação gráfico de barra
  private startAnimationForBarChart(chart: any) {
    let seq2: any, delays2: any, durations2: any;
    seq2 = 0;
    delays2 = 80;
    durations2 = 500;
    chart.on('draw', function (data: any) {
      if (data.type === 'bar') {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq2 = 0;
  }

  private retornaMaiorValor(numeros: number[]) {
    let maiorValor;

    for (const numero of numeros) {
      if (!maiorValor || numero > maiorValor) {
        maiorValor = numero;
      }
    }

    return maiorValor;
  }

  // gráfico barra dupla
  private geraGraficoBarraDupla(dados: GraficoBarra, id) {

    const dataMultipleBarsChart = {
      labels: dados.rotulos,
      series: dados.valores
    };

    const optionsMultipleBarsChart = {
      seriesBarDistance: 10,
      axisX: {
        showGrid: false
      },
      height: '150px'
    };

    const responsiveOptionsMultipleBarsChart: any = [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function (value: any) {
            return value[0];
          }
        }
      }]
    ];

    const multipleBarsChart = new Chartist.Bar(id, dataMultipleBarsChart,
      optionsMultipleBarsChart, responsiveOptionsMultipleBarsChart);

    // start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(multipleBarsChart);
  }

  // gráfico barra
  private geraGraficoBarra(dados: GraficoBarra, id) {



    const dataChart = {
      labels: dados.rotulos,
      series: [
        dados.valores
      ],
    };

    const optionsChart = {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: this.retornaMaiorValor(dados.valores),
      chartPadding: { top: 0, right: 5, bottom: 0, left: 0 },
      plugins: [

      ]
    };
    const responsiveOptions: any = [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }
      }]
    ];
    const chart = new Chartist.Bar(id, dataChart, optionsChart, responsiveOptions);

    this.startAnimationForBarChart(chart);
  }




  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // quantidadeDeOrcamentos(id) {
  //   this.geraGraficoBarra(this.orcamentosUsuario[id >= 4 ? 3 : id], '#orcamentosChart');
  // }

  irradiacao(irrad: Irradiacao) {

    const graficoIrradiacao: GraficoBarra = {
      rotulos: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez', 'Med'],
      valores: [irrad.jan, irrad.fev, irrad.mar, irrad.abr, irrad.mai, irrad.jun, irrad.jul, irrad.ago, irrad.set, irrad.out, irrad.nov, irrad.dez, irrad.med]
    };

    this.geraGraficoBarra(graficoIrradiacao, '#irradiacaoChart');
  }

  estimativaDeEnergiaGerada(meses: number[]) {

    const graficoEstimativa: GraficoBarra = {
      rotulos: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      valores: meses
    };

    this.geraGraficoBarra(graficoEstimativa, '#estimativaChart');
  }
  // expectativaOrcamento(id) {
  //   this.geraGraficoBarraDupla(this.graficoExpectativaOrcamento[id >= 4 ? 3 : id], '#expectativaOrcamentoChart');
  // }
}
